import React, {ErrorInfo, PureComponent, ReactNode} from 'react';

import {ExtendedError} from '../../../libs/shared/core/src/helpers/types/customErrors';
import {reportToBugsnag} from '../../../libs/shared/core/src/services/bugsnag/bugsnag';

/*
 * Props.
 */

interface MarkdownRendererErrorBoundaryProps {
  children: ReactNode;
  debugIdentifier: string;
  FallBackComponent: React.ComponentType<{error: unknown; debugIdentifier: string}>;
}

/*
 * Component.
 */

interface ErrorBoundaryState {
  error?: unknown;
}

export class MarkdownRendererErrorBoundary extends PureComponent<
  MarkdownRendererErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: MarkdownRendererErrorBoundaryProps) {
    super(props);

    this.state = {};
  }

  static getDerivedStateFromError(error: unknown) {
    return {error};
  }

  componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
    const extendedError = new ExtendedError('MarkdownRendererErrorBoundary', error);
    reportToBugsnag(extendedError, {
      metadata: {
        debugIdentifier: this.props.debugIdentifier,
      },
    });
  }

  render() {
    if (this.state.error) {
      return (
        <this.props.FallBackComponent error={this.state.error} debugIdentifier={this.props.debugIdentifier} />
      );
    }

    return this.props.children;
  }
}
